














import { Component } from "vue-property-decorator";
import CdkFavorite from "./CdkFavorite.vue";

@Component
export default class CdkFavoriteIcon extends CdkFavorite {
  get tooltip() {
    if (this.isFavorite) {
      return "als Favorit entfernen";
    }
    return "als Favorit markieren";
  }
}
